import { createApp } from 'vue'
import {store} from "./store";
import App from './App.vue'
import main from '../src/router/main'

createApp(App).use(main).use(store).mount('#app');